import Grid from '@mui/material/Grid'

const GridHeader = ({ h2, noCenter, text, children }) => {
  const centerStyle = noCenter
    ? {}
    : { display: 'flex', justifyContent: 'center', alignItems: 'center' }

  const content = text || children

  return (
    <Grid size={12}>
      <div style={centerStyle}>
        {h2 ? <h2>{content}</h2> : <h4>{content}</h4>}
      </div>
    </Grid>
  )
}

export default GridHeader
